///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2026, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2026 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

export { Assembly } from "./Api/Assembly";
export { Client } from "./Api/Client";
export { ClashTest } from "./Api/ClashTest";
export * from "./Api/ClientEvents";
export { File } from "./Api/File";
export { FetchError, statusText } from "./Api/FetchError";
export { Job } from "./Api/Job";
export { IHttpClient } from "./Api/IHttpClient";
export { IAssociatedFileData, IClashItem, IModelTransformMatrix } from "./Api/IAssembly";
export * from "./Api/IFile";
export { IRoleActions } from "./Api/IRole";
export * from "./Api/ISharedLink";
export { IShortUserDesc } from "./Api/IUser";
export { Member } from "./Api/Member";
export { Model } from "./Api/Model";
export { OAuthClient } from "./Api/OAuthClient";
export { Permission } from "./Api/Permission";
export { Project } from "./Api/Project";
export * from "./Api/Endpoint";
export { Role } from "./Api/Role";
export * from "./Api/Plugin";
export * from "./Api/SharedLink";
export * from "./Api/SharedFile";
export { User } from "./Api/User";
export * from "./Api/Utils";

export const version = "CLIENT_JS_VERSION";
